import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0019',
    ecrans: ['00-2']
});
